import React, { useState } from "react";
import {
  MarginActiveTogglerIcon,
  MarginBottomIcon,
  MarginLeftIcon,
  MarginRightIcon,
  MarginTogglerIcon,
  MarginTopIcon,
} from "../../assets/ui-icons";
import { Tooltip } from "../input";
import { INPUT_LIMITS } from "../input-limits";
const MarginInput = ({ value, onChange, min = 0, max, className }) => {
  var rawValue = value;
  const [toggler, setToggler] = useState(false);
  if (value === undefined || value === null) {
    value = { left: 0, right: 0, top: 0, bottom: 0 };
  }

  value = {
    left: parseInt(value?.left) || 0,
    right: parseInt(value?.right) || 0,
    top: parseInt(value?.top) || 0,
    bottom: parseInt(value?.bottom) || 0,
  };

  return (
    <div className="text-grigora-base">
      <div className="text-ui-text-heading mb-2">Margin</div>
      <div className="flex items-center ">
        <div className="flex-1">
          {toggler ? (
            <div className="flex flex-col gap-2">
              <div className="flex gap-2 ">
                <div className="editor-input-box w-1/2 bg-ui-light-white rounded-full px-3 flex gap-1">
                  <input
                    type="number"
                    name="marginleft"
                    min={min ? min : INPUT_LIMITS["margin-input"].min}
                    max={max ? max : INPUT_LIMITS["margin-input"].max}
                    className="no-arrows w-full bg-ui-light-white outline-none"
                    value={value.left}
                    onChange={(e) =>
                      onChange({
                        ...(rawValue ? rawValue : {}),
                        left: e.target.value + "px",
                      })
                    }
                  />
                  <div>
                    <MarginLeftIcon />
                  </div>
                </div>
                <div className="editor-input-box w-1/2 bg-ui-light-white rounded-full px-3 flex gap-1">
                  <input
                    type="number"
                    min={min ? min : INPUT_LIMITS["margin-input"].min}
                    max={max ? max : INPUT_LIMITS["margin-input"].max}
                    name="margintop"
                    className="no-arrows w-full bg-ui-light-white outline-none"
                    value={value.top}
                    onChange={(e) =>
                      onChange({
                        ...(rawValue ? rawValue : {}),
                        top: e.target.value + "px",
                      })
                    }
                  />
                  <div>
                    <MarginTopIcon />
                  </div>
                </div>
              </div>
              <div className="flex gap-2 ">
                <div className="editor-input-box w-1/2 bg-ui-light-white rounded-full px-3 flex gap-1">
                  <input
                    min={min ? min : INPUT_LIMITS["margin-input"].min}
                    max={max ? max : INPUT_LIMITS["margin-input"].max}
                    type="number"
                    name="marginright"
                    className="no-arrows w-full bg-ui-light-white outline-none"
                    value={value.right}
                    onChange={(e) =>
                      onChange({
                        ...(rawValue ? rawValue : {}),
                        right: e.target.value + "px",
                      })
                    }
                  />
                  <div>
                    <MarginRightIcon />
                  </div>
                </div>
                <div className="editor-input-box w-1/2 bg-ui-light-white rounded-full px-3 flex gap-1">
                  <input
                    min={min ? min : INPUT_LIMITS["margin-input"].min}
                    max={max ? max : INPUT_LIMITS["margin-input"].max}
                    type="number"
                    name="marginbottom"
                    className="no-arrows w-full bg-ui-light-white outline-none"
                    value={value.bottom}
                    onChange={(e) =>
                      onChange({
                        ...(rawValue ? rawValue : {}),
                        bottom: e.target.value + "px",
                      })
                    }
                  />
                  <div>
                    <MarginBottomIcon />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={`flex ${toggler ? "gap-2" : ""}`}>
              <div className="editor-input-box py-[7px] w-full bg-ui-light-white rounded-full px-3 flex gap-1">
                <input
                  min={min ? min : INPUT_LIMITS["margin-input"].min}
                  max={max ? max : INPUT_LIMITS["margin-input"].max}
                  type="number"
                  name="marginall"
                  className="no-arrows w-full bg-ui-light-white outline-none"
                  value={value.bottom}
                  onChange={(e) =>
                    onChange({
                      top: e.target.value + "px",
                      bottom: e.target.value + "px",
                      left: e.target.value + "px",
                      right: e.target.value + "px",
                    })
                  }
                />
                <Tooltip text="Split" placement="left">
                  <div
                    className="ml-auto border cursor-pointer h-fit"
                    onClick={() => setToggler(!toggler)}
                  >
                    <MarginTogglerIcon className="w-[22px] h-[22px]" />
                  </div>
                </Tooltip>
              </div>
            </div>
          )}
        </div>

        {toggler ? (
          <div className="w-24 flex">
            <Tooltip text="Join" placement="left">
              <div
                className="ml-auto cursor-pointer"
                onClick={() => setToggler(!toggler)}
              >
                {toggler ? (
                  <MarginActiveTogglerIcon className="w-[22px] h-[22px]" />
                ) : (
                  ""
                )}
              </div>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default MarginInput;
